var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnwbAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5627_693)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_5627_693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.775115 39.3791C-0.775115 39.3791 -3.55778 46.8968 -5.60426 51.2443C-7.57693 55.4351 -10.2986 56.8651 -12.4763 56.7162C-14.8515 56.5515 -16.2635 54.8954 -16.2114 52.2305C-16.1471 48.9282 -14.1035 45.3693 -12.64 43.6824C-11.3058 42.1431 -7.44899 38.4388 -0.775115 39.3791ZM-3.58468 34.2009C-9.41641 34.7737 -13.9529 36.4386 -18.557 40.6477C-22.1094 43.8936 -24.4298 48.982 -24.5338 53.0218C-24.6683 58.2607 -20.7341 62.9235 -12.9389 61.7136C-10.8287 61.3872 -8.17338 59.636 -8.17338 59.636L-6.95492 61.485L-0.822028 61.4905L8.85467 36.2549C6.98272 35.3137 2.35236 33.6169 -3.58468 34.2009Z",
    fill: "#1C428D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5431 57.9572L49.3599 34.918H58.0547L49.7821 56.5294C52.2512 57.8151 56.8812 57.0934 58.8732 52.6215L65.6285 34.918H74.3699L66.0412 56.5695C69.4892 57.7029 73.2026 57.0934 75.0962 52.6235L81.8849 34.918H90.5567L83.6391 52.8091C81.9039 56.8132 79.0812 62.3008 69.4009 62.3008C66.1586 62.3008 63.2182 61.1558 61.3367 59.6549C59.2115 60.9561 54.7691 62.3008 51.4228 62.3008C48.0765 62.3008 41.9974 61.1076 40.5431 57.9572Z",
    fill: "#1C428D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5725 36.1443L5.83911 61.5184H14.7393L22.9623 40.216C24.1141 39.9247 25.8863 39.6838 27.3531 39.6838C30.2313 39.6838 31.4694 40.793 31.2749 42.2434C31.2319 42.5794 31.1256 42.9173 30.9573 43.306L23.9626 61.5184H32.8719L39.7538 43.6426C40.0287 42.9173 40.2373 42.2434 40.3246 41.5663C40.8384 37.6554 38.016 34.3177 29.4957 34.3081C26.8128 34.3053 24.4287 34.481 22.8996 34.6641C21.5047 34.8288 18.9904 35.187 15.5725 36.1443Z",
    fill: "#1C428D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.9118 93.9846L-24.5496 88.227L-31.1191 93.707C-42.6874 92.2839 -51.3917 86.1572 -54.4093 76.7679C-43.3816 69.4788 -33.265 63.7744 -33.265 63.7744C-29.7177 68.5562 -26.6726 70.1349 -21.7917 71.1667L-23.8232 86.4081L-19.6386 80.5831L-20.4692 84.6732L-11.0287 71.7214C-6.18047 70.933 -0.826583 68.8666 4.31096 65.9377L13.8668 79.2924C0.769068 88.9917 -12.5147 93.5299 -23.9118 93.9846Z",
    fill: "url(#paint0_radial_5627_693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9212 11.4518C1.14231 11.5032 -7.37572 13.3117 -16.8795 17.2767C-19.1756 18.2346 -21.3647 19.3997 -23.484 20.6542C-23.484 20.6547 -23.4864 20.6552 -23.4864 20.6557C-23.9934 20.9558 -24.4961 21.2607 -24.9954 21.5697C-25.0563 21.6073 -25.1172 21.6449 -25.178 21.6826C-25.6809 21.9952 -26.1818 22.3099 -26.6779 22.6279L-19.5568 32.5824C-19.1893 32.3629 -18.8185 32.1494 -18.4453 31.9413C-18.0742 31.7345 -17.7008 31.5328 -17.3251 31.3363C-17.3226 31.3351 -17.3207 31.3341 -17.3184 31.3329C-12.6059 28.8692 -7.53786 27.2616 -2.74666 26.5854L7.01704 13.6946L4.64063 26.2759C9.5039 26.3635 14.0657 27.8261 17.4612 30.4145L35.7843 19.115C27.7021 14.2236 18.9227 11.3857 8.9212 11.4518ZM-19.5568 32.5824L-26.6783 22.6288C-26.8707 22.752 -27.0594 22.8804 -27.2507 23.0051L-20.2387 33.0086C-20.0134 32.8651 -19.7867 32.7228 -19.5568 32.5824Z",
    fill: "url(#paint1_linear_5627_693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1056 71.5622L27.5548 71.5678C-9.80026 109.749 -50.6233 100.506 -57.3145 77.2233C-64.6044 51.8581 -39.0958 23.6712 -12.6443 14.1687C-36.7289 19.0549 -74.2024 52.9447 -62.4415 85.797C-54.3362 108.438 -14.4008 115.04 20.1021 88.0095L17.5022 84.3759C23.4583 79.3732 27.4804 74.6781 29.1056 71.5622Z",
    fill: "url(#paint2_radial_5627_693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33.3169 47.4583C-35.8456 52.6522 -36.3926 58.025 -34.5976 62.5563L-33.4548 61.8541C-33.4725 61.8213 -33.4898 61.7887 -33.5072 61.7556C-35.7062 57.6075 -35.5267 52.5079 -33.3169 47.4583ZM-32.5307 63.3218L-33.8561 64.1368C-33.5873 64.624 -33.2924 65.0992 -32.9646 65.5598C-30.4462 69.0969 -26.6019 71.4177 -21.9606 72.4512L-21.6059 69.7941C-25.9817 68.9378 -29.6576 66.9356 -32.1525 63.8206C-32.2824 63.6553 -32.4066 63.4901 -32.5307 63.3218ZM3.37931 64.6357C-1.81729 67.5263 -7.08799 69.2862 -12.007 69.9594L-20.5193 81.8093L-21.4137 86.848L-10.5452 72.578C-5.69697 71.7897 -0.0490136 69.9531 5.08821 67.0241L3.37931 64.6357Z",
    fill: "url(#paint3_radial_5627_693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02636 19.0028L4.64062 26.2727C5.34925 26.2806 6.01982 26.3279 6.71991 26.3945L8.76313 14.2031L6.02636 19.0028Z",
    fill: "#E96216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8241 19.1162C24.6164 9.41988 6.0543 7.70113 -12.657 14.1765L-12.6371 14.1723C-39.0888 23.6747 -64.5973 51.8617 -57.3073 77.2269C-50.616 100.51 -9.79339 109.753 27.5617 71.5716H23.5301C23.5301 71.5716 18.8407 76.1019 13.859 79.2773L13.8727 79.2963C0.776602 88.9952 -12.5085 93.5341 -23.9049 93.9894L-24.543 88.2325L-31.1113 93.711C-42.6812 92.2885 -51.3842 86.1627 -54.4029 76.7709L-32.5291 63.322C-32.992 62.701 -33.2655 62.1889 -33.454 61.8546L-54.8969 75.033C-57.0524 66.4544 -55.6552 57.7826 -51.8098 49.7053L-42.8718 46.5689L-48.5683 43.9014C-43.2863 35.6794 -35.5498 28.3156 -26.6705 22.6318C-23.5663 20.6417 -20.3395 18.7268 -16.8724 17.2803C-16.1933 16.9969 -15.5198 16.7249 -14.8509 16.4635C5.88432 8.36182 21.8724 10.6947 35.7913 19.1188L35.8241 19.1162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70348 15.2716L7.01711 13.6946L-2.74817 26.5844C-1.97426 26.482 -1.33811 26.4039 -0.564526 26.3475L6.70348 15.2716Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5627_693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6196 35.0608C56.1728 35.6969 55.5557 36.1709 54.8988 36.1821C54.3187 36.1923 53.7732 35.8618 54.1094 34.8147C54.457 33.727 55.174 32.064 55.174 32.064C56.8682 31.3872 57.4184 32.2523 57.399 32.924C57.3867 33.3499 57.1752 34.2698 56.6196 35.0608ZM59.3369 32.1375C59.0266 30.9792 58.1042 30.5108 56.8058 30.5531C56.4813 30.5636 56.1022 30.6142 55.7116 30.6864L56.8578 27.7239H54.6419L50.9265 37.3062L50.8982 37.3755H50.8996L50.8982 37.3787L50.9008 37.3755L52.4494 37.3743L53.089 36.912C53.089 36.912 53.4423 37.3538 54.1973 37.4588C56.1211 37.7266 57.7406 36.5805 58.6027 35.2586C59.2112 34.327 59.5764 33.0308 59.3369 32.1375Z",
    fill: "#1C428D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7304 31.8448C28.7304 31.8448 28.0275 33.7242 27.5105 34.8111C27.0121 35.8588 26.3245 36.2163 25.7744 36.179C25.1743 36.1379 24.8176 35.7238 24.8308 35.0576C24.847 34.232 25.3633 33.3423 25.733 32.9206C26.0701 32.5358 27.0444 31.6097 28.7304 31.8448ZM28.0207 30.5502C26.5474 30.6934 25.4013 31.1097 24.2382 32.1619C23.3407 32.9734 22.7545 34.2455 22.7283 35.2554C22.6943 36.5652 23.6882 37.7309 25.6575 37.4284C26.1906 37.3468 26.8614 36.909 26.8614 36.909L27.1692 37.3712L28.7186 37.3726L31.1632 31.0637C30.6903 30.8284 29.5205 30.4042 28.0207 30.5502Z",
    fill: "#1C428D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1687 36.4893L41.3961 30.7295H43.5927L41.5028 36.1324C42.1265 36.4538 43.2962 36.2733 43.7995 35.1554L45.5061 30.7295H47.7144L45.6103 36.1424C46.4814 36.4257 47.4195 36.2733 47.8979 35.1559L49.6129 30.7295H51.8037L50.0561 35.2023C49.6178 36.2033 48.9047 37.5752 46.4591 37.5752C45.64 37.5752 44.8971 37.289 44.4218 36.9137C43.8849 37.239 42.7626 37.5752 41.9173 37.5752C41.0719 37.5752 39.5361 37.2769 39.1687 36.4893Z",
    fill: "#1C428D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8604 31.0362L30.4014 37.3797H32.6499L34.7273 32.0541C35.0183 31.9813 35.466 31.9211 35.8366 31.9211C36.5637 31.9211 36.8764 32.1984 36.8273 32.561C36.8164 32.645 36.7896 32.7294 36.7471 32.8266L34.98 37.3797H37.2308L38.9693 32.9108C39.0388 32.7294 39.0915 32.561 39.1136 32.3917C39.2433 31.414 38.5303 30.5795 36.3778 30.5772C35.7 30.5765 35.0978 30.6204 34.7114 30.6661C34.359 30.7073 33.7238 30.7969 32.8604 31.0362Z",
    fill: "#1C428D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8854 45.4961L22.7243 44.0567L21.0646 45.4267C18.1421 45.071 15.9431 43.5393 15.1808 41.192C17.9667 39.3697 20.5225 37.9436 20.5225 37.9436C21.4187 39.139 22.1879 39.5337 23.421 39.7917L22.9078 43.602L23.965 42.1458L23.7551 43.1683L26.1401 39.9303C27.3649 39.7333 28.7175 39.2167 30.0154 38.4844L32.4295 41.8231C29.1206 44.2479 25.7647 45.3825 22.8854 45.4961Z",
    fill: "url(#paint4_radial_5627_693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1801 24.8628C29.2149 24.8757 27.063 25.3278 24.662 26.3191C24.082 26.5585 23.5289 26.8498 22.9935 27.1634C22.9935 27.1635 22.9929 27.1637 22.9929 27.1638C22.8648 27.2388 22.7378 27.3151 22.6117 27.3923C22.5963 27.4017 22.5809 27.4111 22.5655 27.4205C22.4385 27.4987 22.312 27.5773 22.1866 27.6569L23.9856 30.1455C24.0785 30.0906 24.1722 30.0372 24.2665 29.9852C24.3602 29.9335 24.4545 29.8831 24.5494 29.8339C24.5501 29.8336 24.5506 29.8334 24.5511 29.8331C25.7417 29.2172 27.022 28.8153 28.2324 28.6462L30.699 25.4235L30.0987 28.5689C31.3273 28.5908 32.4798 28.9564 33.3376 29.6035L37.9666 26.7786C35.9247 25.5558 33.7068 24.8463 31.1801 24.8628ZM23.9856 30.1455L22.1865 27.6571C22.1379 27.6879 22.0903 27.72 22.0419 27.7512L23.8134 30.252C23.8703 30.2161 23.9276 30.1806 23.9856 30.1455Z",
    fill: "url(#paint5_linear_5627_693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0555 40.7572C14.511 38.6129 14.8645 36.4449 15.8357 34.4253L18.0936 33.6414L16.6547 32.9741C17.9892 30.9191 19.9435 29.0782 22.1865 27.6572L23.9857 30.1455C22.3059 31.1612 21.1105 32.5054 20.5095 33.8645C19.8706 35.163 19.8581 36.4301 20.3116 37.5629L15.0555 40.7572Z",
    fill: "url(#paint6_radial_5627_693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2793 39.8906L35.8875 39.892C26.4504 49.4374 16.1372 47.1266 14.4468 41.3059C12.6052 34.9646 19.0494 27.9179 25.7319 25.5422C19.6474 26.7638 10.1804 35.2362 13.1516 43.4493C15.1992 49.1095 25.2882 50.7601 34.0047 44.0024L33.3479 43.094C34.8526 41.8434 35.8687 40.6696 36.2793 39.8906Z",
    fill: "url(#paint7_radial_5627_693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7424 42.4523L23.7424 42.452L25.8929 39.4898L23.7424 42.4523Z",
    fill: "#5D65B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5094 33.8645C19.8706 35.163 19.7324 36.5062 20.1858 37.639L20.4745 37.4635C20.4701 37.4553 20.4657 37.4471 20.4613 37.4388C19.9058 36.4018 19.9511 35.1269 20.5094 33.8645ZM20.708 37.8304L20.3732 38.0342C20.4411 38.1559 20.5156 38.2747 20.5984 38.3899C21.2346 39.2742 22.2058 39.8544 23.3783 40.1127L23.4679 39.4485C22.3625 39.2344 21.4338 38.7338 20.8036 37.9551C20.7707 37.9138 20.7394 37.8725 20.708 37.8304ZM29.78 38.1589C28.4672 38.8815 27.1356 39.3215 25.8929 39.4898L23.7424 42.4523L23.5165 43.7119L26.2622 40.1444C27.487 39.9474 28.9139 39.4882 30.2117 38.756L29.78 38.1589Z",
    fill: "url(#paint8_radial_5627_693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1859 37.6393C20.1859 37.6394 20.1859 37.6392 20.1859 37.6393ZM20.4612 37.4389C19.9057 36.4019 19.9511 35.127 20.5094 33.8646C20.5125 33.8583 20.5155 33.8522 20.5186 33.8459C19.9524 35.1144 19.9031 36.3967 20.4612 37.4389Z",
    fill: "#5D65B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4487 26.7507L30.0986 28.5682C30.2777 28.5702 30.4471 28.582 30.6239 28.5986L31.1401 25.5508L30.4487 26.7507Z",
    fill: "#E96216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9766 26.7791C35.1451 24.355 30.4558 23.9253 25.7287 25.5441L25.7337 25.5431C19.0512 27.9187 12.6069 34.9654 14.4486 41.3067C16.1391 47.1275 26.4522 49.4382 35.8892 39.8929H34.8707C34.8707 39.8929 33.686 41.0255 32.4275 41.8193L32.431 41.8241C29.1225 44.2488 25.7662 45.3835 22.8871 45.4974L22.7259 44.0581L21.0666 45.4277C18.1437 45.0721 15.945 43.5407 15.1824 41.1927L20.7084 37.8305C20.5915 37.6753 20.5224 37.5472 20.4747 37.4636L15.0576 40.7583C14.513 38.6136 14.866 36.4457 15.8375 34.4263L18.0955 33.6422L16.6564 32.9754C17.9908 30.9198 19.9453 29.0789 22.1885 27.6579C22.9727 27.1604 23.7879 26.6817 24.6638 26.3201C24.8353 26.2492 25.0055 26.1812 25.1745 26.1159C30.4128 24.0905 34.4519 24.6737 37.9683 26.7797L37.9766 26.7791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6198 25.8178L30.699 25.4236L28.232 28.646C28.4275 28.6204 28.5882 28.6009 28.7837 28.5868L30.6198 25.8178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9384 39.5225C23.7185 39.4931 23.669 39.4849 23.4673 39.4482L22.9073 43.6019L23.1403 43.2807L23.9384 39.5225Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5627_693",
    x: -97,
    y: -22,
    width: 250,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_5627_693"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5627_693",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-23.4666 27.912) scale(65.2878 65.2878)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850394,
    stopColor: "#176FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C63B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5627_693",
    x1: -14.0576,
    y1: 28.2937,
    x2: 13.653,
    y2: 19.3753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68A12"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5627_693",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-23.4666 27.9128) scale(65.2874 65.2875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850394,
    stopColor: "#176FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C63B7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5627_693",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-23.4666 27.9121) scale(65.2878 65.2878)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B64B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850394,
    stopColor: "#254AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2745A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5627_693",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9979 28.978) scale(16.4938 16.3219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850394,
    stopColor: "#176FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C63B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5627_693",
    x1: 25.3749,
    y1: 29.0733,
    x2: 32.3616,
    y2: 26.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68A12"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_5627_693",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9979 28.9782) scale(16.4936 16.3218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850394,
    stopColor: "#176FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C63B7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_5627_693",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9979 28.9783) scale(16.4937 16.3219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850394,
    stopColor: "#176FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C63B7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_5627_693",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9979 28.978) scale(16.4938 16.3219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B64B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850394,
    stopColor: "#254AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2745A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5627_693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5627_693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 25,
    fill: "white",
    transform: "translate(12 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnwbAppIcon);
export default __webpack_public_path__ + "static/media/anwb-app-icon.9037722a1569b658974a2acd62d88929.svg";
export { ForwardRef as ReactComponent };